var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _vm.codes.length > 0
      ? _c("div", { staticClass: "mt-2" }, [
          _c("div", { staticClass: "text-decoration-underline" }, [
            _vm._v("Aktive Codes:"),
          ]),
          _c(
            "ul",
            _vm._l(_vm.codes, function (c) {
              return _c("li", [_c("b", [_vm._v(_vm._s(c.title))])])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }